<kendo-dialog *ngIf="active" (close)="closeForm()" [width]="500">
    <kendo-dialog-titlebar>Please confirm</kendo-dialog-titlebar>

    <p style="margin: 30px; text-align: center;">Are you sure you want to permanently delete {{entityName}}?</p>

    <kendo-dialog-actions>
        <button class="k-button k-primary" (click)="onDelete($event)">Delete</button>
        <button class="k-button" (click)="onCancel($event)">Cancel</button>
    </kendo-dialog-actions>
</kendo-dialog>